import React from 'react'

import { Outlet } from 'react-router-dom'

import { Footer } from '@/components/ui'
import { FullscreenButton } from '@/components/ui/nav/FullscreenButton'
import { ProfileMenuSection } from '@/components/ui/nav/ProfileMenuSection'
import { useAuth } from '@/hooks'
import { AlarmCodeProvider, DashboardProvider } from '@/providers'

import AppNav from './AppNav'
import { NavModeProvider } from './NavModeContext'

/**
 * The app shell: the nav on the left and the page on the right, both running to the top of
 * the window, over a full-width footer holding the profile menu and full screen toggle.
 */
const Layout: React.FC = () => {
  const { logout, isAuthenticated, user, originalUser } = useAuth()

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } })
  }

  return (
    <AlarmCodeProvider>
      <DashboardProvider>
        <NavModeProvider>
          <div className="flex flex-col h-dvh min-w-0">
            <div className="flex flex-1 min-h-0 min-w-0">
              <AppNav />
              {/* isolate: z-indexes inside a page stay inside it, below the nav's menu button and drawer. */}
              <main className="isolate flex-1 min-w-0 min-h-0 overflow-auto bg-base-200">
                <Outlet />
              </main>
            </div>
            <Footer
              leading={
                <>
                  {isAuthenticated && (
                    <ProfileMenuSection
                      handleLogout={handleLogout}
                      user={user ?? undefined}
                      originalUser={originalUser}
                    />
                  )}
                  <FullscreenButton />
                </>
              }
            />
          </div>
        </NavModeProvider>
      </DashboardProvider>
    </AlarmCodeProvider>
  )
}
export default Layout
